import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './AnchorText.styles'

const AnchorText = ({ copy, id }) => (
  <Styled.AnchorTextComponent id={ id }>
    {!copy.includes('*') ? `* ${ copy }` : copy}
  </Styled.AnchorTextComponent>
)

AnchorText.propTypes = {
  copy: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default AnchorText
